export default __webpack_public_path__ + "0ca035dd25e3fc6b4050edd5f283dd25.jpg";